import { render } from "./RevisionEnvioEntregadoPage.vue?vue&type=template&id=26ce930c&scoped=true"
import script from "./RevisionEnvioEntregadoPage.vue?vue&type=script&lang=js"
export * from "./RevisionEnvioEntregadoPage.vue?vue&type=script&lang=js"

import "./RevisionEnvioEntregadoPage.vue?vue&type=style&index=0&id=26ce930c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ce930c"]])

export default __exports__